var React = require('react');

function PatternTwocircle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Combined Shape"),React.createElement("path",{"d":"M20.847 75.125C8.425 68.337 0 55.153 0 40 0 17.91 17.91 0 40 0s40 17.91 40 40c0 1.48-.08 2.942-.237 4.38 2.712-.25 5.46-.38 8.237-.38 48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88c0-21.684 7.843-41.537 20.847-56.875zm0 0C26.535 78.233 33.06 80 40 80c20.61 0 37.58-15.59 39.763-35.62-23.568 2.188-44.44 13.67-58.916 30.745z","style":{"mixBlendMode":"multiply"},"fill":"#B1D78A","fillRule":"evenodd","key":1})]);
}

PatternTwocircle.defaultProps = {"width":"176","height":"220","viewBox":"0 0 176 220"};

module.exports = PatternTwocircle;

PatternTwocircle.default = PatternTwocircle;
